import { NAME as PARENT_NAME } from '../constants';
export const NAME = `${PARENT_NAME}/progressiveWebApp` as const;

export const PROMPT_TIMEOUT = 60 * 60 * 1000;
export const MAX_PROMPTS = 5;
